import React from "react";
import { FaRocket, FaBolt, FaCogs } from "react-icons/fa";

function BenefitsOFTON() {
  const reasons = [
    {
      title: "Exceptional Speed and Scalability",
      desc: "TON’s multi-threaded architecture supports high transaction speeds and scalable solutions, ideal for high-traffic applications",
      icon: <FaRocket size={35} />,
    },
    {
      title: "Low Latency and Fast Settlement",
      desc: "Benefit from near-instant transaction finality, ensuring quick and seamless user interactions.",
      icon: <FaBolt size={35} />,
    },
    {
      title: "End-to-End Development Solutions",
      desc: "Xeer offers comprehensive support from development to deployment, testing, and maintenance.",
      icon: <FaCogs size={35} />,
    },
  ];

  return (
    <div
      className="services-area pt-120 pb-120 mt-5"
      style={{ background: "#ffffff" }}
    >
      <div className="container text-center">
        <h2 className="title fw-extrabold mb-4">
          Benefits of TON Development with Xeer Technology
        </h2>

        <div className="row g-4 justify-content-center">
          {reasons.map((reason, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div
                className="reason-card border-0 p-5 text-center h-100"
                style={{
                  borderRadius: "32px",
                  background: "#f9faff",
                  border: "1px solid #f0f3ff",
                  transition: "all 0.4s ease",
                  cursor: "default",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.background = "#ffffff";
                  e.currentTarget.style.boxShadow =
                    "0 25px 50px rgba(0, 0, 0, 0.04)";
                  e.currentTarget.style.borderColor = "#3366ff20";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.background = "#f9faff";
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.borderColor = "#f0f3ff";
                }}
              >
                <div
                  className="icon-box mx-auto d-flex align-items-center justify-content-center mb-4"
                  style={{
                    width: "70px",
                    height: "70px",
                    fontSize: "28px", // untouched
                    backgroundColor: "#ffffff",
                    color: reason.color,
                    borderRadius: "20px",
                    boxShadow: "0 10px 20px rgba(0,0,0,0.03)",
                  }}
                >
                  {reason.icon}
                </div>

                <h5 className="fw-bold mb-3" style={{ fontSize: "18px" }}>
                  {reason.title}
                </h5>

                <p
                  style={{
                    fontSize: "14px",
                    color: "#6c757d",
                    lineHeight: "1.7",
                    marginBottom: 0,
                  }}
                >
                  {reason.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BenefitsOFTON;
